import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useSaveRoom() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((roomId, payload) => {
    setSaving(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = roomId
      ? quarkusApi.put(`/rooms/${roomId}`, payload, authHeader)
      : quarkusApi.post('/rooms', payload, authHeader);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
